import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initSentry } from './config/sentry';

// Initialize Sentry monitoring
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    if (process.env.NODE_ENV === 'production') {
      const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;
      navigator.serviceWorker.register(swUrl).catch(function () {});
    } else {
      // Unregister any active service workers in development to prevent caching issues
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister().then((success) => {
            if (success) {
              console.log('Unregistered service worker successfully in development mode');
            }
          });
        }
      });
    }
  });
}
